import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { PaymentsApi } from '@shared/api/rest';
import { GetRequisitesResponse } from '@shared/api/rest/payments';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface RequisitesType {
  data: GetRequisitesResponse[];
  loading: boolean;
  error: string | null;
  get: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useGetRequisitesStore = create<RequisitesType>((set) => ({
  data: [],
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await PaymentsApi.getRequisites(signal);
      set({ data: result?.data ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null }),
}));
